// utils
import axios from '../../utils/axios';

const getNavBarOnboardConfig = async () => {
  try {
    const response = await axios({
      method: 'get',
      url: `/lexus/onboard/api/is_eligible`,
    });
    const res = await response.data;
    return res;
  } catch (error) {
    throw new Error(JSON.stringify(error));
  }
};

export { getNavBarOnboardConfig };
